import * as React from 'react'
import { useMemo } from 'react'

import { ReasonIcon } from './ReasonIcon'
import { reasonTypeToString } from './reasonTypeToString'
import type { ICloseRequirements } from '@user/store/opportunity'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

interface Props {
  reason: ICloseRequirements
}

export function MissingRequirementDetails(props: Props) {
  const {
    reason: { type },
  } = props

  const reasonString = useMemo(() => reasonTypeToString(type), [type])

  return (
    <Stack mt={1.2} alignItems="center" direction="row">
      <Box width={52} mr={0.5}>
        <ReasonIcon type={type} />
      </Box>
      <Typography color="#30383c" fontSize="16px">
        {reasonString}
      </Typography>
    </Stack>
  )
}
